import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user profile */
export const getUserProfile = async () => {
  const res = await get(`/enterprise-api/enterprise_profile`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetUserProfile = (onSuccess: any, onError: any) => {
  return useQuery('enterprise-profile', getUserProfile, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetUserProfile;
